import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isAuthorized = !!localStorage.getItem("ClassAffiliateID"); // true if saved
  if (!isAuthorized) return <Navigate to="/unauthorized" replace />;
  return children;
};

export default ProtectedRoute;
